import { AuthUser, Permissions, RolesWithPermissions } from '../../../types';
import { ROLES_DEFINITION } from '../rolesDefinition';

export const hasPermission = <Resource extends keyof Permissions>(
  user: AuthUser | undefined,
  resource: Resource,
  action: Permissions[Resource]['action'],
  data?: Permissions[Resource]['data']
) => {
  if (!user) {
    return false;
  }

  return user.roles.some((role) => {
    const permission = (ROLES_DEFINITION as RolesWithPermissions)[role][resource]?.[action];

    if (permission === undefined) {
      return false;
    }

    if (typeof permission === 'boolean') {
      return permission;
    }

    return permission(user, data || ({} as Permissions[Resource]['data']));
  });
};
